
import {permissionObj} from "../../../../Helpers/permission";
import {VISITOR_SUB_VIEW_MODEL} from "../Invitation/Model/Model";
import {STATUS_MODEL} from "../../../../enums/statusEnum";
import React from "react";
import {getFullName} from '../../../../Apis/functions';

export const APPROVAL_STATUS_MODEL = [
    STATUS_MODEL.PENDING_REVIEW, //133
    STATUS_MODEL.CHANGES_REQUESTED,//131
    STATUS_MODEL.DENIED,//132
    STATUS_MODEL.APPROVED//130
];

export const VISITOR_STATUS_MODEL = [
    STATUS_MODEL.UNATTENDED,//112
    STATUS_MODEL.REJECTED,//95
    STATUS_MODEL.CANCELED,//96
    STATUS_MODEL.ACCEPTED//92
];

export const STATUS_DOCUMENTATION_MODEL = [
    STATUS_MODEL.PENDING_TO_UPLOAD_INFORMATION,//111
    STATUS_MODEL.CANCELED,//96
    STATUS_MODEL.PENDING_REVIEW,//133
    STATUS_MODEL.APPROVED,//130
    STATUS_MODEL.REJECTED,//95
    STATUS_MODEL.CHANGES_REQUESTED//131
];

export const IDENTITY_VALIDATION_MODEL = [
    STATUS_MODEL.PENDING_TO_UPLOAD_INFORMATION,//111
    STATUS_MODEL.PENDING_REVIEW,//133
    STATUS_MODEL.VALIDATED,//113
    STATUS_MODEL.DENIED//132
];

export const REQUEST_ACCESS_STATUS_MODEL = [
    STATUS_MODEL.REQUESTED, //90
    STATUS_MODEL.APPROVED,//130
    STATUS_MODEL.DENIED//132
];

export const VISITOR_MODEL = {
    id: null,
    userTypeId: null,
    name: '',
    lastName: '',
    secondLastName: '',
    phoneNumber: '',
    email: '',
    identityValidation: null,
    identityValidationType: null,
    identityValidationApprover: null,
    identityValidationDate: null,
    statusId: null,
    selfie: null,
    visitorTypeId: null,
    toRegister: function () {
        return {
            id: this.id,
            userTypeId: this.userTypeId,
            name: this.name,
            lastName: this.lastName,
            secondLastName: this.secondLastName || null,
            phoneNumber: this.phoneNumber,
            email: this.email,
            statusId: this.statusId
        };
    },
    qrFlowToRegister: function () {
        return {
            id: this.id,
            requestedByName: this.name || null,
            requestedByLastName: this.lastName || null,
            requestedBySecondLastName: this.secondLastName || null,
            requestedByPhoneNumber: this.phoneNumber || null,
            requestedByEmail: this.email || null
        };
    },
    setSimple: function (dataVisitor) {
        return {
            ...this,
            id: dataVisitor?.id || dataVisitor?.userId,
            name: dataVisitor?.name,
            lastName: dataVisitor?.firstLastName,
            secondLastName: dataVisitor?.secondLastName,
            phoneNumber: dataVisitor?.phoneNumber,
            email: dataVisitor?.email,
            userTypeId: dataVisitor?.userTypeId
        };
    },
    set: function (data) {
        return {
            ...this,
            id: data.id,
            userTypeId: data.userTypeId || null,
            name: data.name || '',
            lastName: data.lastName || '',
            secondLastName: data.secondLastName || '',
            phoneNumber: data.phoneNumber || '',
            email: data.email || '',
            identityValidation: data.identityValidation?.id,
            identityValidationType: data.identityValidationType,
            statusReason:  data?.identityValidationReason || '',
            identityValidationApprover: getFullName(data?.identityValidationApprover?.name , data?.identityValidationApprover?.lastName ,  data.identityValidationApprover?.secondLastName),
            identityValidationDate: data.identityValidationDate ? data.identityValidationDate: null,
            statusId: data?.status?.id,
            selfie: data?.selfie
        };
    },

    isValid: function () {
        return (
            this.name !== '' &&
            this.lastName !== '' &&
            this.phoneNumber !== '' &&
            this.email !== ''
        );
    },
    clear: function () {
        return {
            ...this,
            name: '',
            lastName: '',
            secondLastName: '',
            phoneNumber: '',
            email: '',
        }
    },
}

export const TABS_VISITOR = {

    INVITATIONS: {
        INDEX: 0,
        TRANS: "invitations",
    },
    REQUESTS: {
        INDEX: 1,
        TRANS: "requests",
    },
    VISITORS: {
        INDEX: 2,
        TRANS: "visitors",
    },
    TYPES: {
        INDEX: 3,
        TRANS: "types",
    }
}

export function TAB_PERMISSION_VISITOR (subView){
    return {
        CREATE: {
            [TABS_VISITOR.INVITATIONS.INDEX]: subView === VISITOR_SUB_VIEW_MODEL.INVITATION.ONGOING? permissionObj?.WEB_VISITOR_INVITATION_CREATE : null, //Change to invitations
            [TABS_VISITOR.VISITORS.INDEX]: subView ==  VISITOR_SUB_VIEW_MODEL.VISITORS.VISITORS ? permissionObj?.WEB_VISITOR_CREATE : null,
            [TABS_VISITOR.TYPES.INDEX]: permissionObj?.WEB_VISITOR_TYPE_CREATE,
        },
        DELETE: {
            [TABS_VISITOR.VISITORS.INDEX]: subView ==  VISITOR_SUB_VIEW_MODEL.VISITORS.VISITORS ? permissionObj?.WEB_VISITOR_DELETE : null,
            [TABS_VISITOR.TYPES.INDEX]: permissionObj?.WEB_VISITOR_TYPE_DELETE,
        },
        EXPORT: {
            [TABS_VISITOR.INVITATIONS.INDEX]: permissionObj?.WEB_VISITOR_INVITATION_EXPORT,
            [TABS_VISITOR.REQUESTS.INDEX]: permissionObj?.WEB_VISITOR_REQUEST_EXPORT,
            [TABS_VISITOR.VISITORS.INDEX]: subView ==  VISITOR_SUB_VIEW_MODEL.VISITORS.VISITORS ? permissionObj?.WEB_VISITOR_EXPORT : null,
        },
        ADVANCE_SEARCH: {
            [TABS_VISITOR.INVITATIONS.INDEX]: permissionObj?.WEB_VISITOR_INVITATION_READ,
            [TABS_VISITOR.REQUESTS.INDEX]: permissionObj?.WEB_VISITOR_REQUEST_READ,
            [TABS_VISITOR.VISITORS.INDEX]: subView ==  VISITOR_SUB_VIEW_MODEL.VISITORS.VISITORS ? permissionObj?.WEB_VISITOR_READ : null
        },
        QR_REQUEST_ACCESS: {
            [TABS_VISITOR.VISITORS.INDEX]: subView ==  VISITOR_SUB_VIEW_MODEL.VISITORS.VISITORS ? permissionObj?.WEB_VISITOR_READ : permissionObj?.WEB_REQUEST_ACCESS_READ,
        }
    }
}
